import React from 'react'
import { UncontrolledTooltip } from 'reactstrap'
import styled, { withTheme } from 'styled-components/macro'
import PropTypes from 'prop-types'
import { Container } from './ShippableIconStyledComponents'
import { MdLocalShipping } from 'react-icons/md'

const IconShipping = React.memo(({ shippable, ...rest }) => {
  const IconShippingPlain = styled(MdLocalShipping).attrs({
    style: shippable ? { opacity: 1 } : { opacity: 0.25 }
  })``
  return <IconShippingPlain {...rest} />
})
IconShipping.displayName = 'IconShipping'
IconShipping.propTypes = {
  shippable: PropTypes.bool
}

const ShippableIcon = React.memo(
  ({ show, theme, id, shippable, className }) => !show ? null : (
    <Container className={className}>
      <IconShipping
        shippable={shippable}
        color={theme.shippingIcon}
        id={`tooltip-${id}`}
      />
      <UncontrolledTooltip placement='top' target={`tooltip-${id}`}>
        {shippable ? 'ship-able' : 'Not ship-able'}
      </UncontrolledTooltip>
    </Container>
  )
)
ShippableIcon.displayName = 'ShippableIcon'

ShippableIcon.defaultProps = {
  shippable: true,
  className: '',
  theme: {}
}

ShippableIcon.propTypes = {
  shippable: PropTypes.bool,
  show: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  theme: PropTypes.object
}

export default withTheme(ShippableIcon)
export { ShippableIcon, IconShipping }
